<template>
  <div class="nav">
    <!-- logo -->
    <div class="logos">
      <img src="/static/img/login/luyu_logo_nav.png" alt />
    </div>

    <!-- 横向导航 -->
    <div style class="across-display">
      <el-menu
        class="el-menu-across"
        style="background: #000; border-bottom-color: #0a1e39"
        mode="horizontal"
        :default-active="across_nav_index"
        @select="across_select"
        text-color="#dadada"
        active-text-color="#fff"
        background-color="#000"
      >
        <template v-for="item in nav_data">
          <el-menu-item
            class="el-menu-item_t"
            :key="item.nav_id"
            :index="item.nav_id"
            v-if="item.onshow.indexOf(Number($cookies.get('auth_grade'))) > -1"
            >{{ item.title }}</el-menu-item
          >
        </template>
      </el-menu>
      <!-- 头像通知 -->
      <div class="user-avatar">
        <div class="hint-main">
          <el-badge :value="el_badge <= 0 ? '' : el_badge">
            <i class="iconfont iconlingdang hint" @click="today_s_data"></i>
          </el-badge>
        </div>

        <div @click="click_avatr">
          <el-avatar>{{ realname }}</el-avatar>
          <i
            :class="[
              visible
                ? 'el-icon-caret-bottom  deg_180'
                : 'el-icon-caret-bottom ',
            ]"
          ></i>
        </div>

        <el-popover
          class="visible"
          placement="left"
          width="200"
          trigger="manual"
          v-model="visible"
        >
          <div
            class="avatar_menu"
            @mouseover="mouseOver"
            @mouseleave="mouseLeave"
          >
            <div
              class="avatar_menu_p"
              @click="click_personal_center"
              v-if="
                $cookies.get('auth_grade') == 90 ||
                $cookies.get('auth_grade') == 80
              "
            >
              <i class="iconfont iconzhongjianren avatar_menu_icon"></i>
              个人中心
            </div>

            <div
              class="avatar_menu_p"
              @click="is_nav = true"
              v-if="$cookies.get('auth_grade') == 90"
            >
              <i class="iconfont icontuichu1 avatar_menu_icon"></i>
              修改密码
            </div>
            <div class="avatar_menu_p" @click="exit">
              <i class="iconfont icontuichu1 avatar_menu_icon"></i>
              退出登录
            </div>
            <div class="avatar_menu_p">
              <i class="iconfont iconprompt avatar_menu_icon"></i>
              版本 v1.0.0
            </div>
          </div>
          <!-- <el-card class="box-card">
            <div v-for="o in 4" :key="o" class="text item">{{'列表内容 ' + o }}</div>
          </el-card>-->
        </el-popover>
      </div>
    </div>
    <div class="line"></div>

    <!-- 侧边导航 -->
    <el-menu
      :default-active="vertical_nav_index"
      class="el-menu-vertical-demo vertical"
      text-color="#333"
      @select="vertical_select"
      :collapse="isCollapse"
    >
      <template
        v-for="item in nav_data[Number($cookies.get('across_nav_index')) - 1]
          .children"
      >
        <el-menu-item
          :key="item.nav_id"
          :index="item.nav_id"
          :class="item.nav_id == vertical_nav_index ? 'menu-item-select' : ''"
          v-if="item.onshow.indexOf(Number($cookies.get('auth_grade'))) > -1"
        >
          <i style="font-size: 18px" :class="item.icon" class="iconfont"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </template>
      <!-- 隐藏键 -->
      <i class="el-icon-s-fold menu-hide" @click="menu_hide_show"></i>
    </el-menu>

    <el-dialog
      :title="dialog_title"
      :visible.sync="dialogVisible"
      style="min-width: 900px"
      :modal-append-to-body="false"
      @close="closeClick"
    >
      <el-tabs
        v-if="!jurisdiction"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="今日回访"
          name="0"
          v-if="!personnel_matters && !Sagent && isShow"
        >
          <el-table
            :data="client_list"
            style="width: 100%; min-height: 50vh"
            v-loading="loading"
          >
            <el-table-column
              prop="client_name"
              label="姓名"
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="client_phone"
              label="手机号"
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="company_name"
              label="地址"
              min-width="280"
            ></el-table-column>
            
          </el-table>
         
        </el-tab-pane>
        <el-tab-pane
          label="待审核"
          name="1"
          v-if="
            ((!jurisdiction &&
              !personnel_matters &&
              $cookies.get('auth_grade') == 80) ||
              $cookies.get('auth_grade') == 100 ||
              $cookies.get('auth_grade') == 90) &&
            isShow
          "
        >
          <el-button
            v-if="$cookies.get('auth_grade') == 100"
            type="primary"
            style="float: right"
            size="mini"
            @click="tiao"
            >跳转</el-button
          >
          <el-table
            :data="client_list"
            style="width: 100%; min-height: 50vh"
            v-loading="loading"
          >
            <el-table-column
              v-if="$cookies.get('auth_grade') == 100"
              prop="agent_company_name"
              label="代理商公司"
            ></el-table-column>
            <el-table-column
              prop="company_name"
              label="公司名"
              min-width="280"
            ></el-table-column>
            <el-table-column
              prop="client_name"
              label="姓名"
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="client_phone"
              label="手机号"
              min-width="180"
            ></el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-checkbox-group v-model="checkList" @change="checkListfn">
                  <el-checkbox :label="scope.row.deal_id">{{''}}</el-checkbox>
                </el-checkbox-group>
              </template>
            </el-table-column>
          </el-table>
           <div class="ignore">
            <el-button type="primary" @click="ignoreFn(3)">忽略3天</el-button
            ><el-button type="primary" @click="ignoreFn(7)">忽略7天</el-button
            ><el-button type="primary" @click="ignoreFn(15)"
              >忽略15天</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="充值账号"
          name="2"
          v-if="
            ($cookies.get('auth_grade') == 100 ||
              $cookies.get('auth_grade') == 61) &&
            isShow
          "
        >
          <el-table
            :data="recharge_client_list"
            style="width: 100%; min-height: 50vh"
            v-loading="loading"
          >
            <el-table-column prop="company_name" label="公司名称" width="180">
            </el-table-column>

            <el-table-column prop="client_name" label="姓名"> </el-table-column>
            <el-table-column prop="client_phone" label="账号">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane
          label="职位审核"
          name="3"
          v-if="
            ($cookies.get('auth_grade') == 100 ||
              $cookies.get('auth_grade') == 61) &&
            isShow
          "
        >
          <el-button
            v-if="
              $cookies.get('auth_grade') == 100 ||
              $cookies.get('auth_grade') == 61
            "
            type="primary"
            style="float: right"
            size="mini"
            @click="post_audit_tiao"
            >跳转</el-button
          >
          <el-table
            :data="post_audit_list"
            style="width: 100%; min-height: 50vh"
            v-loading="loading"
          >
            <el-table-column
              prop="company_name"
              label="公司名"
            ></el-table-column>
            <el-table-column prop="username" label="用户账号"></el-table-column>
            <el-table-column
              prop="agent_company_name"
              label="所属代理商"
            ></el-table-column>
            <el-table-column
              prop="jd_position_name"
              label="招聘职位"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="is_nav"
      style="min-width: 900px"
      :modal-append-to-body="false"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="输入密码">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="form.password_q" type="password"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_nav = false">取 消</el-button>
          <el-button type="primary" @click="navYse">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import { nav_data } from "@/utils/nav.js";

export default {
  name: "navigation",
  data() {
    return {
      isShow: true,
      Super_administrator: false,
      personnel_matters: false,
      // 隐藏部分侧边栏
      jurisdiction: false,
      // 竖向导航显示隐藏
      isCollapse: false,
      // 横向导航默认id
      across_nav_index: this.$cookies.get("across_nav_index"),
      // 竖向导航默认id
      vertical_nav_index: this.$cookies.get("vertical_nav_index"),
      reversedMessage_value: [],
      // 头像名字
      realname: "",
      // 点击头像弹框
      visible: false,
      // 今日回访名单数
      el_badge: 0,
      dialogVisible: false,
      client_list: [],
      activeName: "",
      dialog_title: "今日回访",
      loading: false,
      Sagent: false,
      nav_data: [],
      index: 0,
      is_nav: false,
      form: {},
      recharge_client_list: [],
      post_audit_list: [],
      post_audit_count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      // 点击跳转之后，那个页面不显示
      tiaozhuan: false,
      // 选中的值
      checkList: [],
    };
  },
  created: function (e) {
    if (
      this.$cookies.get("auth_grade") == 100 ||
      (this.$cookies.get("auth_grade") == 90 &&
        this.$cookies.get("agent_company_name")) ||
      (this.$cookies.get("auth_grade") == 30 &&
        !this.$cookies.get("agent_company_name")) ||
      (this.$cookies.get("auth_grade") == 20 &&
        !this.$cookies.get("agent_company_name"))
    ) {
      console.log(nav_data[4].nav_id != 5);
      if (nav_data[4].nav_id != 5) {
        nav_data.splice(4, 0, {
          title: "代理商管理",
          nav_id: "5",
          children: [
            {
              title: "24猎代理商",
              nav_id: "5-1",
              icon: "icontongji_tuanduishuju",
              path: "/er_hunting",
              onshow: [100, 90, 30, 20, 61],
            },
            {
              title: "24猎省代",
              nav_id: "5-2",
              icon: "icontongji_tuanduishuju",
              path: "/pro_hunting",
              onshow: [100, 30, 20, 61],
            },
          ],
          onshow: [100, 90, 30, 20, 61],
        });
      }
    }
    if (
      (this.$cookies.get("auth_grade") == 20 ||
        this.$cookies.get("auth_grade") == 30) &&
      this.$cookies.get("agent_company_name") == null
    ) {
      nav_data[2].onshow.splice(3, 2);
      console.log(nav_data[2], "nav_data");
    }

    this.nav_data = nav_data;
    if (this.$cookies.get("auth_grade") == 20) {
      this.jurisdiction = false;
    }
    if (this.$cookies.get("auth_grade") == 100) {
      this.Super_administrator = true;
    }
    if (this.$cookies.get("auth_grade") == 90) {
      this.Sagent = true;
      // console.log('人事')
      // this.positive_remind(2)
    }
    if (this.$cookies.get("auth_grade") == 50) {
      this.personnel_matters = true;
      console.log("人事");
      // this.positive_remind(2)
    } else {
      // console.log("其他");
      this.today_follow_data(1);
    }

    if (!this.$cookies.get("across_nav_index")) {
      this.$cookies.set("across_nav_index", "1");
      this.$cookies.set("vertical_nav_index", "1-1");
    }
    let realname = this.$cookies.get("realname");
    try {
      this.realname = realname.substring(realname.length - 2, realname.length);
    } catch (e) {
      this.realname = "游客";
    }
    if (
      this.$cookies.get("auth_grade") == 100 ||
      this.$cookies.get("auth_grade") == 61
    ) {
      this.recharge_client_lista();
      this.post_audit();
    }
  },
  // 无线轮回发起请求
  // updated() {
  //   if (
  //     this.$cookies.get("auth_grade") == 100 ||
  //     this.$cookies.get("auth_grade") == 61
  //   ) {
  //     this.setTIme();
  //   }
  // },
  watch: {
    $route(to) {
      if (to.path === "/position_review") {
        if (
          this.$cookies.get("auth_grade") == 100 ||
          this.$cookies.get("auth_grade") == 61
        ) {
          this.post_audit();
        }
      } else if (to.path == "/team_data") {
        if (
          $cookies.get("auth_grade") == 80 ||
          $cookies.get("auth_grade") == 100 ||
          $cookies.get("auth_grade") == 90
        ) {
          this.audit_deal_list(2);
        }
      } else if (to.path === "/index") {
        this.today_follow_data();

        if (
          this.$cookies.get("auth_grade") == 100 ||
          this.$cookies.get("auth_grade") == 61
        ) {
          this.post_audit();
          this.recharge_client_lista();
        }
        if (
          $cookies.get("auth_grade") == 80 ||
          $cookies.get("auth_grade") == 100 ||
          $cookies.get("auth_grade") == 90
        ) {
          this.audit_deal_list(2);
        }
      } else {
        this.el_badge =
          this.post_audit_count + this.count1 + this.count2 + this.count3;
      }
    },
  },
  methods: {
    checkListfn() {
      console.log(this.checkList);
    },
    ignoreFn(num) {
      if(this.checkList.length == 0){
        this.$message.error('至少选择一个')
        return;
      }
      var obj = {
        deal_list:this.checkList,
        neglect_time:num,
      } 
      this.loading = true;
      console.log(obj)
      require("post", "/lufish_sale/v1/neglect_remind/", obj).then(
        (res) => {
          if (!res.code) {
            this.$message.success(res.msg);
            this.deal_list = [];
            this.audit_deal_list(2);
          }
        }
      );
      console.log(num);
    },
    isTrue() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },

    created_nav() {
      this.is_nav = true;
    },
    navYse() {
      console.log(this.form.password, this.form.password_q);
      if (!this.form.password) {
        this.$message.warning("请输入密码");
        return false;
      }
      if (!this.form.password_q) {
        this.$message.warning("请确认密码");
        return false;
      }
      if (this.form.password !== this.form.password_q) {
        this.$message.warning("两次密码不一致");
        return false;
      }

      let obj = {
        password: this.form.password,
        staff_id: this.$cookies.get("staff_id"),
      };
      require("post", "/lufish_user/v1/lufish_update_password/", obj).then(
        (res) => {
          if (!res.code) {
            this.$message.success("修改密码成功！");
            this.is_nav = false;
          }
        }
      );
    },
    tiao() {
      this.$router.push({
        path: "/to_examine",
      });
      this.across_nav_index = "3";
      this.vertical_nav_index = "3-7";
      this.$cookies.set("across_nav_index", "3");
      // 竖向导航默认id
      this.$cookies.set("vertical_nav_index", "3-7");
      this.tiaozhuan = true;
      this.dialogVisible = false;
    },
    // 退出
    exit() {
      console.log("退出", this.$cookies.keys());
      this.$cookies.keys().map((item) => {
        this.$cookies.remove(item);
      });
      this.$router.push({ path: "/" });
    },

    // 点击头像
    click_avatr() {
      this.visible = !this.visible;
    },

    // 选中竖菜单
    vertical_select(e) {
      this.vertical_nav_index = e;
      // 竖向导航默认id
      this.$cookies.set("vertical_nav_index", e);
      let nav = this.nav_data[Number(this.across_nav_index) - 1].children;
      console.log(nav);
      nav.map((res) => {
        console.log(res.nav_id, e);
        if (e == res.nav_id) {
          this.$router.push({ path: res.path });
        }
      });
    },

    // 选中横菜单
    across_select(e) {
      console.log(e, "e");
      this.across_nav_index = e;
      this.$cookies.set("across_nav_index", e);
      let nav = this.nav_data[Number(this.across_nav_index) - 1].children;
      let path = "";
      let index = 0;
      console.log(nav);
      nav.map((res) => {
        if (
          res.onshow.indexOf(Number(this.$cookies.get("auth_grade"))) > -1 &&
          index == 0
        ) {
          console.log(res);
          path = res.path;
          index++;
          this.vertical_nav_index = res.nav_id;
          this.$cookies.set("vertical_nav_index", res.nav_id);
          // return false;
        }
      });
      this.$router.push({ path });
    },

    // 隐藏侧边菜单
    menu_hide_show() {
      this.isCollapse = !this.isCollapse;
    },

    // 点击个人中心
    click_personal_center() {
      // this.$message({
      //   message: '恭喜你，个人中心',
      //   type: 'success',
      // })
      this.$router.push({
        path: "/personalCenter",
      });
    },

    // 移入头像菜单框
    mouseOver() {
      clearTimeout(this.u_timer);
    },

    // 移出头像菜单框
    mouseLeave() {
      let _this = this;
      this.u_timer = setTimeout(function () {
        _this.click_avatr();
      }, 800);
    },

    //  跳转页面
    router_path() {
      console.log("routerpath", this.across_nav_index, this.vertical_nav_index);
      let router_dict = {};
      for (var i in this.$menu_data) {
        console.log();
        router_dict[this.$menu_data[i]] = i;
      }
      this.$router.push({ path: router_dict[this.vertical_nav_index] });
    },
    // 当天回访客户
    today_follow_data(e) {
      this.el_badge = this.el_badge - this.count1;
      require("post", "/lufish_index_data/v1/today_follow_data/", {}).then(
        (res) => {
          if (!res.code) {
            this.client_list = res.data.client_list;
            if (e == 1) {
              if (res.data.client_list.length != 0) {
                this.activeName = "0";
                this.dialogVisible = true;
              }
              this.count1 = Number(res.data.client_list.length);
              this.el_badge += Number(res.data.client_list.length);
              if (this.$cookies.get("auth_grade") != 20) {
                this.audit_deal_list(2);
              } else {
                this.activeName = "0";
              }
              this.isTrue();
            } else {
              this.count1 = Number(res.data.client_list.length);
              this.el_badge += Number(res.data.client_list.length);
              this.isTrue();
              this.loading = false;
            }
          } else {
            this.dialogVisible = false;
            // this.$message.error(res.msg)
            this.loading = false;
          }
        }
      );
    },
    audit_deal_list(e) {
      this.el_badge = this.el_badge - this.count2;
      let audit_deal_list_length = 1;
      let url = "";
      if (this.$cookies.get("auth_grade") == 80) {
        url = "/lufish_sale/v1/agent_audit_deal_list/";
      } else if (this.$cookies.get("auth_grade") == 90) {
        url = "/lufish_sale/v1/province_agent_audit_deal_list/";
      } else {
        url = "/lufish_sale/v1/audit_deal_list/";
      }
      require("post", url, {}).then((res) => {
        if (!res.code) {
          if (e == 2) {
            if (res.data.deal_count != 0) {
              if (this.activeName == "0") {
                this.activeName = "1";
                this.dialog_title = "待审核";
              }
              if (this.tiaozhuan === true) {
                this.dialogVisible = false;
              } else {
                this.dialogVisible = true;
              }
            } else {
              this.dialogVisible = false;
            }
            this.client_list = res.data.deal_data;
            this.count2 = Number(res.data.deal_count);
            this.el_badge += Number(res.data.deal_count);
            this.isTrue();
            if (this.$cookies.get("auth_grade") == 100) {
              // this.positive_remind(2)
            } else {
              this.loading = false;
            }
          } else if (e == 1) {
            this.isTrue();
            this.count2 = Number(res.data.deal_count);
            this.el_badge += Number(res.data.deal_count);
            this.loading = false;
            this.client_list = res.data.deal_data;
          }
          this.loading = false;
        } else {
          // this.$message.error(res.msg)
          this.loading = false;
        }
        this.tiaozhuan = false;
        // console.log('当天的审核', res.data);
      });
    },
    recharge_client_lista() {
      this.el_badge = this.el_badge - this.count3;
      // console.log("啊是擦上是的");
      let obj = {
        recharge_status: 0,
        is_bell_remind: 1,
      };
      require("POST", "/lufish_sale/v1/recharge_client_list/", obj).then(
        (res) => {
          console.log(res);
          if (!res.code) {
            this.recharge_client_list = res.data;
            this.count3 = Number(res.count);
            this.el_badge += Number(res.count);
            this.loading = false;
            this.isTrue();
          }
        }
      );
    },
    positive_remind(e) {
      require("post", "/lufish_hrm/v1/positive_remind/", {}).then((res) => {
        if (!res.code) {
          console.log("2d415as4534d53453 ", e);
          if (e == 2) {
            if (res.data.length) {
              this.dialogVisible = true;
              this.el_badge += Number(res.data.length);

              if (this.activeName == "") {
                this.client_list = res.data;
                this.activeName = "2";
                this.dialog_title = "转正列表";
              }
            }
          } else {
            this.client_list = res.data;
          }
          this.loading = false;
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      });
    },
    today_s_data() {
      if (this.el_badge != 0) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          console.log(1);
          if (this.post_audit_count > 0) {
            this.activeName = "3";
          } else if (this.count1 > 0) {
            this.activeName = "0";
          } else if (this.count2 > 0) {
            this.activeName = "1";
          } else if (this.count3 > 0) {
            this.activeName = "2";
          }
        });
      }
    },
    handleClose(done) {
      console.log("关闭", done);
    },
    handleClick(e) {
      console.log("e--》", e.name);
      this.loading = true;
      if (e.name == "0") {
        this.dialog_title = "今日回访";
        this.today_follow_data();
      } else if (e.name == "1") {
        this.dialog_title = "待审核";
        this.audit_deal_list(1);
      } else if (e.name == "2") {
        this.dialog_title = "转正列表";
        this.recharge_client_lista();
      } else if (e.name == "3") {
        this.dialog_title = "职位审核";
        this.post_audit();
      }
    },
    // 铃铛职位审核列表获取
    post_audit() {
      this.el_badge = this.el_badge - this.post_audit_count;
      let obj = {
        is_bell_remind: 1,
        jd_status: 1,
        page: 1,
      };
      require("POST", "/hr24_index_data/v1/all_jd/", obj).then((res) => {
        if (res.code === 0) {
          if (Number(res.data.jd_data.length) > 0) {
            if (this.tiaozhuan === true) {
              this.dialogVisible = false;
            } else {
              this.dialogVisible = true;
            }
          } else {
            if (this.dialog_title == "职位审核") {
              this.dialogVisible = true;
            } else {
              this.dialogVisible = false;
            }
          }
          if ((this.activeName = "0")) {
            this.activeName = "3";
          }
          this.isTrue();
          // 解决铃铛的提示数一直增加
          this.post_audit_count = Number(res.data.jd_data.length);
          this.el_badge += Number(res.data.jd_data.length);
          this.post_audit_list = res.data.jd_data;
          this.loading = false;
        }
        this.tiaozhuan = false;
      });
    },
    // 铃铛里面职位审核跳转
    post_audit_tiao() {
      this.$router.push({
        path: "/position_review",
        query: {
          page: 0,
          jd_status: 1,
        },
      });
      this.across_nav_index = "2";
      this.vertical_nav_index = "2-14";
      this.$cookies.set("across_nav_index", this.across_nav_index);
      // 竖向导航默认id
      this.$cookies.set("vertical_nav_index", this.vertical_nav_index);
      this.tiaozhuan = true;
      this.dialogVisible = false;
    },
    // 弹框点击关闭
    closeClick() {
      this.activeName = "0";
    },
  },
};
</script>

<style scoped>
.deg_180 {
  transform: rotate(180deg);
}

/* //解决导航bug */
/* .el-submenu__title:hover {
  background-color: #0a1e39 !important;
} */
/* .el-menu-item:hover {
  background: #0a1e39 !important;
  color: #fff !important;
} */

.avatar_menu_p {
  height: 50px;
  line-height: 50px;
  cursor: pointer; /*鼠标悬停变小手*/
}

.avatar_menu_p :hover {
  color: #3e84e9;
}

.avatar_menu_icon {
  font-size: 24px;
  position: relative;
  top: 1px;
  margin-right: 6px;
}
.avatar_menu {
  padding: 6px;
  font-size: 14px;
}
.across-display {
  width: 100%;
  box-shadow: #ccc 2px 3px 6px 1px;
}

.el-menu--collapse {
  width: 64px;
  height: 80vh;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.menu-hide {
  position: absolute;
  color: #ccc;
  font-size: 30px;
  bottom: 30px;
  right: 20px;
}

.el-badge__content.is-fixed {
  right: 15px;
  top: 13px;
}

.hint-main {
  float: left;
  margin-right: 38px;
  margin-top: 12px;
  /* padding-top: 6px; */
  color: #ccc;
  cursor: pointer;
}

.hint {
  font-size: 30px;
  color: #ccc;
}

.el-popover {
  right: 50px;
}

.el-menu--horizontal > .el-menu-item {
  font-size: 16px;
}
.logos {
  position: absolute;
  height: 60px;
  width: 180px;
  text-align: center;
  background: #000;
}
.logos img {
  width: 80%;
  /* height: 48px; */
  padding: 6px 0px 0px;
  /* margin-left: 17px; */
}

.el-icon-caret-bottom {
  font-size: 18px;
  position: relative;
  bottom: 20px;
  left: 4px;
  color: #888;
  cursor: pointer;
}

.el-avatar {
  height: 50px;
  width: 50px;
  line-height: 50px;
  font-size: 16px;
  background: #3e84e9;
  cursor: pointer;
}

.user-avatar {
  width: 250px;
  height: 50px;
  position: absolute;
  top: 6px;
  right: 0px;
  /* line-height: 50px; */
}

.vertical {
  border-radius: 0 0 30px;
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 0px;
}

.menu-item-select {
  border-left: 2px solid #3e84e9;
  background-color: #ecf5ff;
}

.menu-item-select .el-menu-item {
  border-left: 2px solid #3e84e9;
  /* color: #333; */
}

/* .iconfont {
  color: #333;
} */

.el-menu-across.el-menu--horizontal .el-menu-item {
  margin: 0 20px;
  padding: 0;
}

.el-menu-item {
  font-size: 14px;
  letter-spacing: 2.1px;
  /* color: #3e84e9; */
}
.el-menu-item_t {
  font-size: 16px;
  letter-spacing: 2.5px;
  /* color: #ccc; */
}

.el-submenu__title {
  font-size: 16px;
}

.el-menu--collapse {
  height: calc(100vh - 68px);
}

.el-menu-item-group__title {
  font-size: 18px;
}

.el-menu-across {
  /* padding-top: 6px; */
  padding-bottom: 0px;
  margin-left: 180px;
  padding-left: 70px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  margin-top: 12px;
  height: calc(100vh - 68px);
  overflow-x: auto;
}
.el-menu-vertical-demo::-webkit-scrollbar {
  display: none;
}

.nav {
  width: 100%;
  min-width: 1200px;
  position: fixed;
  z-index: 300;
  top: 0;
  left: 0;
}

.ignore {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation_bar/navigation_bar.vue